import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedModuleService {
  private readonly selectedValue = new BehaviorSubject<any>(null);
  currentSelectedValue = this.selectedValue.asObservable();

  constructor() { }

  changeSelectedValue(value: any) {
    this.selectedValue.next(value);
  }
}